import QCListContainer from './components/QCListContainer'

// Sync route definition
export default {
  path       : '/qc/list',
  indexRoute : { component: QCListContainer }
}



// WEBPACK FOOTER //
// ./src/routes/QCList/index.jsx